import * as React from 'react';
const SvgChevronDown = (props) => (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width={20}
        height={20}
        fill='none'
        {...props}>

        <g>
            <path
                fill='currentColor'
                d='M9.996 12.502a.64.64 0 0 1-.46-.192L5.671 8.446a.52.52 0 0 1-.174-.39.57.57 0 0 1 .188-.39q.18-.182.387-.182.205 0 .387.181L10 11.226l3.56-3.56a.5.5 0 0 1 .384-.167q.21.006.39.187.183.181.182.387 0 .207-.188.393l-3.863 3.844a.8.8 0 0 1-.22.144.6.6 0 0 1-.25.048'
            />
        </g>
    </svg>
);
export default SvgChevronDown;
